<template>
    <div class="ma-0 ">  
        <!-- //---------------------DIALOG -->
        <div>   
            <v-dialog
                v-model="dialog_view_aggregated_sales"
                scrollable   
                :persistent="false" :overlay="false"
                max-width="1100px"
                transition="dialog-transition" >
                <v-card rounded="lg" > 
                    <!-- Period controls -->
                    <v-card color="">
                        <v-card-text>
                            <v-row dense align="center">
                                <v-btn-toggle v-model="period_type" mandatory dense color="primary" group>
                                    <v-btn value="day">Daily</v-btn>
                                    <v-btn value="week">Weekly</v-btn>
                                    <v-btn value="month">Monthly</v-btn>
                                </v-btn-toggle> 
                                <v-spacer></v-spacer>
                                <v-btn v-if="!vs.mdAndUp" color="primary" icon @click="EXIT_DIALOG"><v-icon>close</v-icon></v-btn>
                                <v-col cols="12" md="4">
                                    <v-menu
                                        v-model="date_menu"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                :value="SelectedPeriodLabel"
                                                label="Period"
                                                prepend-inner-icon="mdi-calendar"
                                                readonly dense 
                                                filled
                                                hide-details
                                                v-bind="attrs"
                                                v-on="on"
                                            />
                                        </template>
                                        <v-date-picker
                                            v-model="selected_date"
                                            :type="period_type === 'month' ? 'month' : 'date'"
                                            no-title
                                            @input="ON_DATE_PICKED"
                                        />
                                    </v-menu>
                                </v-col>
                                <v-btn v-if="vs.mdAndUp" color="primary" icon @click="EXIT_DIALOG"><v-icon>close</v-icon></v-btn>
                            </v-row>
                        </v-card-text>
                    </v-card> 

                    

                    <mbs-item-manager
                        :table_title="ReportTypes[period_type]?.names || 'Cashup Aggregated Sales'"
                        table_title_icon="mdi-script-text-outline"
                        :add_vertical_lines="true"
                        :top_label="false"
                        :row_click="false"
                        :show_select="false"
                        :row_click_action="false" 

                        :name_items="NAME_ITEMS"
                        :name_item="NAME_ITEM"
                        :header_items="HEADER_ITEMS" 
                        :data_items="ReportItemsList"   
                        :loading="loading_report"
                        :is_joined="true"  
                        :total_item_values="TOTAL_ITEM_VALUES"  

                        :table_actions="table_actions" 
                        :table_tabs="tabs"
                        @SELECT_TABLE_ACTION="TABLE_ACTION"
                        @SELECT_ITEM_ACTION="ITEM_ACTION"
                    />

                    <!-- Summary stats -->
                    <!-- <v-card-text  class="pb-0">
                        <v-row dense>
                            <v-col v-for="(stat,i) in SummaryStats" :key="i" cols="6" md="2">
                                <v-card outlined>
                                    <v-card-text class="text-center pa-3">
                                        <div class="text-caption grey--text text--darken-1">{{stat.label}}</div>
                                        <div class="text-h6 font-weight-bold">{{stat.value}}</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text> -->
                </v-card> 
            </v-dialog>  
          
            <!-- //print -->
            <div v-if="auto_print.printing"> 
                <mbs-auto-print 
                    @finish_print="FINISH_PRINT"
                    :show="true"  
                    :auto_print="auto_print.auto"
                    :auto_printer_name="auto_print.auto_printer_name"
                    :com_printer="auto_print.com_printer"  
                    :data="auto_print.print_data"
                    :type="auto_print.print_type"
                    :title="auto_print.print_title"
                    :printing_action="auto_print.printing_action"
                    :display_option="auto_print.display_option" 
                    />  
            </div> 
        </div>
    </div>
</template> 
<script>
let PAGE_NAME = 'CASHUP_AGGREGATED_REPORT'
import DATA from "../../../plugins/DATA"
import DB from "../../../plugins/db/localDB"
import {mapState } from "vuex" 
import { mdiReceiptTextArrowRight } from '@mdi/js';
export default { 
    props:['till','device','cashup'],
    data(){
        return{  
            body_height:0,
             
            input:{}, 
            inputLoading:false,  
            DATA:DATA,   
            dialog_record_expenses:false,   
            dialog_view_aggregated_sales:false,  
            dialog_doc_show:false, 

            auto_print:{
                auto:false,
                printing:false, 
                print_data:null,
                print_type:null,
                com_printer:false, 
                print_title:null, 
                auto_printer_name:null,
                printing_action:null, 
                display_option:'',  
            },
            NAME_ITEMS:DATA.ITEMS.AGGREGATED_REPORTS.names,
            NAME_ITEM:DATA.ITEMS.AGGREGATED_REPORTS.name,
            VALUE_ITEMS:DATA.ITEMS.AGGREGATED_REPORTS.values,
            VALUE_ITEM:DATA.ITEMS.AGGREGATED_REPORTS.value,  

            table_actions:[  
                {type:"btn",icon:"mdi-printer",action:"print_aggregated_report",color:"secondary", outlined:false,  text:"Print"},  
                {type:"action",btn:true,icon:"mdi-refresh",action:"refresh",color:"secondary", outlined:false,  text:"Refresh"},   
                {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"},  
            ],
            tabs:[
                {name:"Items"},
                {name:"Groups"},
                {name:"Departments"}
            ], 
            dialog_doc_show:false,
            input_show_doc:{
                top_header:true
            },

            // period-based aggregated report state (ported from AGGREGATED_SALES_REPORT)
            period_type:'day',
            selected_date:null,
            date_menu:false,
            report_data:null,
            loading_report:false,
            dialog_audit_aggregate_sales:true,
        } 
    }, 
    created() {
        try {
            this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);      
            this.MBS.events.$on('ON_VIEW_AGGREGATED_SALES', this.ON_VIEW_AGGREGATED_SALES);   

            if (this.period_type === 'month') {
                this.selected_date = this.moment().format('YYYY-MM')
            } else {
                this.selected_date = this.moment().format('YYYY-MM-DD')
            }
        } catch (error) {
            this.MBS.actions.error({
                error:error,
                from:'created',
                page:PAGE_NAME, 
            }) 
        }
    },
    mounted(){  
    },
    computed:{
        route(){
            return this.$route
        },
        vs(){
            return this.$vuetify.breakpoint
        }, 
        vsh(){
            return this.vs.height
        },  
        SALES_PATH(){  
            let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.sale_orders,true) 
            return path
        }, 
        ...mapState({
            loading:state=>state.load.loading,
            processes:state=>state.load.processes,
            responses:state=>state.load.responses,
        }),
        ...mapState({
            us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
            ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
            SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'], 
        }),
        ...mapState({
            Tills: state=> state.items[(DATA.ITEMS.TILLS.values).toUpperCase()],
            JoinedTills: state=> state.join[(DATA.ITEMS.TILLS.values).toUpperCase()], 

            // needed to join aggregated report item keys -> item name/category/department, etc.
            Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
            JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()],

            // the aggregated report node itself (day/week/month, keyed by period_key/till_key)
            AggregatedReports: state=> state.items[(DATA.ITEMS.AGGREGATED_REPORTS.values).toUpperCase()],
        }), 
        moment(){
            return this.MBS.date.moment
        },
        TillsData(){ 
            let Tills = this.Tills
            let JoinedTills = this.JoinedTills   
            return JoinedTills?JoinedTills:Tills
        },
        ItemsData(){ 
            let items = this.JoinedItems?this.JoinedItems:this.Items
            return items || []
        },
        SelectedPeriodLabel(){
            let date = this.selected_date
            if(!date){return null}
            if(this.period_type === 'month'){
                return this.moment(date).format('MMMM YYYY')
            }
            if(this.period_type === 'week'){
                return 'Week of '+this.moment(date).format('Do MMM YYYY')
            }
            return this.moment(date).format('Do MMM YYYY')
        },

        // ASSUMPTION: the till this dialog reports on is the till the cashup ran on. If your
        // cashup objects key this differently (e.g. via day_shift/outlet instead of till_key),
        // point this at the right field — everything below (FETCH_REPORT, CurrentReport) keys
        // off this single computed.

        DeviceTill(){
            let tills = this.TillsData
            let device = this.device
            if (tills && device) {
                let till = tills?.find(till=>till.computer_code == device.code)
                return till 
            }
            return null
        },
        TillKey(){
            const till = this.till
            const device_till = this.DeviceTill
            const cashup = this.cashup
            if (till) {
                return till.key
            }else if (device_till) {
                return device_till.key
            }
            return cashup?.till_key 
        },
        CurrentTill(){
            let tills = this.TillsData 
            let till = tills?.find(till=>till.key == this.TillKey)
            return till  
        },

        // Since this dialog is always scoped to one cashup/till (no till selector, unlike
        // AGGREGATED_SALES_REPORT), it always reads from the *_TILL_* report buckets.
        ReportTypes(){
            return {
                day:DATA.ITEMS.AGGREGATED_TILL_DAIRY_REPORTS,
                week:DATA.ITEMS.AGGREGATED_TILL_WEEKLY_REPORTS,
                month:DATA.ITEMS.AGGREGATED_TILL_MONTHLY_REPORTS,
            }
        },

        CurrentReport(){
            let timestamp = this.moment.utc(this.selected_date).valueOf()
            let period_keys = this.GET_PERIOD_KEYS(timestamp)
            let period_type = this.period_type
            let till_key = this.TillKey
            let period_key = this.period_type === 'day' ? period_keys?.dayKey
                : this.period_type === 'week' ? period_keys?.weekKey
                : period_keys?.monthKey
            const reports = this.AggregatedReports

            if (reports?.period_key == period_key && reports?.period_type == period_type && reports?.till_key == till_key) { 
                return reports
            } 
            return null
        },

        SummaryStats(){
            let r = this.CurrentReport
            if(!r){return []}
            let money = (v,d)=> this.MBS.actions.money(this.toNumber(v),d)
            return [
                {label:'Invoices', value: money(r.invoice_count,0)},
                {label:'Items Sold', value: money(r.item_total_quantity,0)},
                {label:'Total Sales', value: money(r.item_total_sold_price)},
                {label:'Total VAT', value: money(r.invoice_total_vat)},
                {label:'Total Discount', value: money(r.item_total_discount)},
            ]
        },

        ReportItemsList(){
            let report = this.CurrentReport
            let joined_items = this.ItemsData
            let joined_item_map = {}
            joined_items.forEach(item => {
                joined_item_map[item.key]=item
            });
            let items = report?report.items:null
            if(!items){return []}
            let list = Object.keys(items).map(item_key=>{
                let item = items[item_key] || {}
                let join = joined_item_map[item_key] || {}
                let special_code = this.toNumber(join?.special_code)
                let quantity = this.toNumber(item.quantity)
                let price = this.toNumber(item.price)
                let total_price = this.toNumber(item.total_price)
                let total_sold_price = this.toNumber(item.total_sold_price)
                let total_discount = this.toNumber(item.total_discount)
                let totalVAT = this.toNumber(item.totalVAT)
                return {
                    item_key,
                    ...join,
                    ...item,
                    quantity, price, total_price, total_sold_price, total_discount, totalVAT, special_code,

                    price_:this.MBS.actions.money(price),
                    total_price_:this.MBS.actions.money(total_price),
                    total_sold_price_:this.MBS.actions.money(total_sold_price),
                    total_discount_:this.MBS.actions.money(total_discount),
                    vat:this.MBS.actions.money(totalVAT)||"0",
                }
            })

            if (list?.find(item=>item.special_code>0)) {
                list.sort(this.MBS.actions.dynamicSort("special_code",true))  
            }else{
                list.sort(this.MBS.actions.dynamicSort("quantity",false))    
            }
            return list
        },

        HEADER_ITEMS(){
            return [ 
                {id:1,name:"General",title:true}, 
                {id:0,name:"",value:'icon_image',color:"primary",size:40,tile:true,show:false},
                {id:0,name:"Barcode",value:'barcode',show:true},
                {id:0,name:"S.Code",value:'special_code',show:true},
                {id:0,name:"Item",value:"name",show:true},
                {id:0,name:"Category",value:"category_name",show:true},
                {id:0,name:"Department",value:'item_department_name',align:'right',show:true},
                {id:0,name:"Quantity",value:'quantity',align:'right',show:true},
                {id:0,name:"Price",value:'price_',align:'right',show:false},
                {id:0,name:"Total Price",value:'total_price_',align:'right',show:false},
                {id:0,name:"Total Sales",value:'total_sold_price_',align:'right',show:true},
                {id:0,name:"Discount",value:'total_discount_',align:'right',show:false},
                {id:0,name:"VAT",value:'vat',align:'right',show:true},
                {id:0,name:"action",align:"right",show:true,item:[ 
                    {name:"View Item",action:"view_item",icon:"mdi-eye"}, 
                ]}, 
            ]
        },  
        TOTAL_ITEM_VALUES(){
            return [  
                {name:'Total Items',value:'quantity'},
                {name:'Total Sales Price',value:'total_sold_price',show_value:'total_sold_price_',money:true}, 
                {name:'Total Discount',value:'total_discount',show_value:'total_discount_',money:true},
                {name:'Total VAT',value:'totalVAT',show_value:'vat',money:true},
            ]
        },
    },
    methods:{  
        // Exact port of AGGREGATED_SALES_REPORT's GET_PERIOD_KEYS — must stay identical since
        // the produced keys have to match the ones the backend writes report nodes under.
        GET_PERIOD_KEYS(dayShiftKey){
            const moment = this.moment
            const dayMoment = moment.utc(this.toNumber(dayShiftKey))
            const dayKey = dayMoment.format('YYYY-MM-DD')
            const weekKey = dayMoment.clone().startOf('isoWeek').format('YYYY-MM-DD')
            const monthKey = dayMoment.format('YYYY-MM')
            return {
                day: dayKey,
                week: weekKey,
                month: monthKey,
                dayKey: String(moment.utc(dayKey).valueOf()),
                weekKey: String(moment.utc(weekKey).valueOf()),
                monthKey: String(moment.utc(monthKey).valueOf())
            }
        },

        // Fetches the aggregated report node for the selected period_type/date, scoped to
        // this cashup's till, straight from Realtime Database (same store action/pattern as
        // AGGREGATED_SALES_REPORT.FETCH_REPORT).
        async FETCH_REPORT(){
            try { 
                if(!this.selected_date){return}
                let company = this.SELECTED_COMPANY
                let company_key = company?company.company_key:null
                if(!company_key){return}

                this.loading_report = true
                this.report_data = null

                let timestamp = this.moment.utc(this.selected_date).valueOf()
                let period_keys = this.GET_PERIOD_KEYS(timestamp)
                let period_key = this.period_type === 'day' ? period_keys?.dayKey
                    : this.period_type === 'week' ? period_keys?.weekKey
                    : period_keys?.monthKey

                if(!period_key){
                    this.loading_report = false
                    return
                }

                this.FI_CLOSE()
                let res = await this.$store.dispatch('fi_get_aggregated_report_items',{
                    company_key:company_key,
                    period_type:this.period_type, // 'day' | 'week' | 'month'
                    period_key:period_key,
                    till_key:this.TillKey||null,
                    on:true
                })

                this.report_data = res?.data || null
            } catch (error) {
                this.report_data = null
                this.MBS.actions.error({
                    error:error,
                    from:'FETCH_REPORT',
                    page:PAGE_NAME,
                })
            } finally {
                this.loading_report = false
            }
        }, 

        FI_CLOSE(){ 
            try { 
                this.$store.dispatch("off_refs",{
                    name:DATA.ITEMS.AGGREGATED_REPORTS.values
                })
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'FI_CLOSE',
                    page:PAGE_NAME, 
                }) 
            }
        },

        TABLE_ACTION(action,item){
            try { 
                if (action == "refresh") { 
                    this.FETCH_REPORT()
                }else if (action == "close") { 
                    this.EXIT_DIALOG()
                }else if (action == "exit") { 
                    this.EXIT_DIALOG()
                }else if (action == "print_aggregated_report") { 
                    this.PRINT_ITEMS()
                }
                // "print_aggregated_report" and "export_excel" continue to be handled the
                // same way they were before (export_excel internally by mbs-item-manager;
                // print_aggregated_report can be wired to auto_print here once you have a
                // print template for the aggregated item list).
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'TABLE_ACTION',
                    page:PAGE_NAME, 
                }) 
            } 
        }, 
        ITEM_ACTION(action,item){
            try { 
                if (action == "view_item") {
                    let item_key = item?item.item_key:null
                    if(!item_key){return}
                    this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/items/"+item_key,true))
                }  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'ITEM_ACTION',
                    page:PAGE_NAME, 
                }) 
            }
        }, 
        ON_VIEW_AGGREGATED_SALES(event){
            try { 
                this.dialog_view_aggregated_sales = true
                if(!this.selected_date){
                    this.selected_date = this.period_type === 'month'
                        ? this.moment().format('YYYY-MM')
                        : this.moment().format('YYYY-MM-DD')
                }
                this.FETCH_REPORT()
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'ON_VIEW_AGGREGATED_SALES',
                    page:PAGE_NAME, 
                }) 
            } 
        },  
        EXIT_DIALOG(){
            try { 
                this.dialog_record_expenses = false   
                this.dialog_view_aggregated_sales = false   
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'TABLE_ACTION',
                    page:PAGE_NAME, 
                }) 
            } 
        }, 
        SHOW_DIALOG_DOCUMENT(payload){
            try {
                let data = {}
                let doc_type = payload?.doc_type
                let doc_title = payload?.doc_title
                if(payload?.data){
                    data = payload?.data
                }
                if(payload?.key){
                    data.key = payload?.key
                }
                if(!this.input_show_doc){
                    this.input_show_doc = {}
                } 
                if(data=={}){return null}

                this.input_show_doc.data = {...data,merge_doc_type:"receipt"}
                this.input_show_doc.data_key = data.key
                this.input_show_doc.title = doc_title
                this.input_show_doc.document_type = doc_type?doc_type:"invoice"
                this.dialog_doc_show = true  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'SHOW_DIALOG_DOCUMENT',
                    page:PAGE_NAME, 
                }) 
            }
        },
        ON_DATE_PICKED(){
            this.date_menu = false
            this.FETCH_REPORT()
        },
        async PRINT_ITEMS(){ 
                try { 
                    
                    const report = this.CurrentReport
                    const items = this.ReportItemsList
                    const till = this.CurrentTill
                    const printer = till?.printers?.[0]
                    console.log(report,'report....i..');
                    console.log(items,'items....i..');
                    console.log(till,'till....i..');
  
                  
                    let printer_name = printer?printer.name:null
                    let printer_type_name = printer?printer.printer_type_name:null
                    
            
                    this.auto_print.printing = false
                    setTimeout(() => { 
                        this.auto_print.auto_printer_name = printer_name
                        this.auto_print.print_type = "sale_aggregated_report"
                        this.auto_print.print_data = {
                            report,
                            joined_items:items,
                        } 
                        this.auto_print.printing = true   
                    }, 5); 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'PRINT_ITEMS',
                        page:PAGE_NAME, 
                    }) 
                }
            },
        FINISH_PRINT(action,payload){
            try {   
                console.log(action,'action....');
                console.log(payload,'payload....');
                let canceled = payload?payload.canceled:null
                if(!action){return}
                if (action.code == PAGE_NAME+"=CLOSE-CASHUP") {
                    this.$store.dispatch("fi_upload_cashups")
                    // this.$store.dispatch("fi_uploadSales")
                    this.SUBMIT_CLOSE_CASHUP(action.data) 
                    this.REFRESH_DATA()  
                }
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'FINISH_PRINT',
                    page:PAGE_NAME, 
                }) 
            } 
        },
         
        //-------------[main]
        async DIALOG_YES(action){ 
            try {
                if (action.code) {
                    if (action.code ===PAGE_NAME+'=CONFIRM-SELECT-COMPANY') {
                        if (action.YES) {
                            setTimeout(() => { 
                                this.input.check = true 
                                this.MBS.actions.dialogInput({
                                    show:true,
                                    fixed:true,
                                    title:"CONFIRM",
                                    text:"Enter your password to confirm switching to "+this.MBS.actions.TEXT_UP(action.data.company_name)+".",
                                    btnYes:"CONFIRM",
                                    field:[
                                        {field:"password",label:'Password',type:'password'}
                                    ],
                                    action:{
                                        ...action,
                                        code:PAGE_NAME+"=SELECT-COMPANY",
                                    }
                                })  
                            }, this.MBS.data.ACTION_REFRESH_TIME); 
                        } else {
                            
                        }  
                    } 
                    if (action.code ===PAGE_NAME+'=SELECT-COMPANY') {
                        if (action.YES) {
                            setTimeout(() => { 
                                let password = action.password
                                password = password?this.MBS.crypt.encrypt(password):null 
                                if (!password) { 
                                    this.MBS.actions.dialog(null,true,false,"ERROR","Wrong password entered",null,"OK")
                                }else if (password!==this.ud.p_uid) { 
                                    this.MBS.actions.dialog(null,true,false,"ERROR","Wrong password entered",null,"OK")
                                } else {
                                    this.SELECT_COMPANY(action.data) 
                                }   
                            }, this.MBS.data.ACTION_REFRESH_TIME);    
                        } else {
                            
                        }
                    }   
                } 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'DIALOG_YES',
                    page:PAGE_NAME, 
                }) 
            }  
        },
    },
    beforeDestroy(){
        this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);       
        this.MBS.events.$off('ON_RECODE_EXPENSE', this.ON_RECODE_EXPENSE);       
        this.MBS.events.$off('ON_VIEW_AGGREGATED_SALES', this.ON_VIEW_AGGREGATED_SALES);       
        this.FI_CLOSE()
    },
    watch:{   
        period_type(){
            try {
                if (this.period_type === 'month') {
                    this.selected_date = this.moment().format('YYYY-MM')
                } else {
                    this.selected_date = this.moment().format('YYYY-MM-DD')
                }
                this.FETCH_REPORT()
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'watch.period_type',
                    page:PAGE_NAME,
                })
            }
        },
        dialog_view_aggregated_sales(value){
            if(value){
                this.FETCH_REPORT()
            }
        },
    }
}
</script>